import { WifiOff } from 'lucide-react';
import { useOfflineStatus } from '@/hooks/use-offline';

interface PdfOfflineNoticeProps {
  className?: string;
}

export function PdfOfflineNotice({ className = '' }: PdfOfflineNoticeProps) {
  const { isOffline } = useOfflineStatus();

  if (!isOffline) return null;

  return (
    <div className={`flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800 ${className}`}>
      <WifiOff className="h-4 w-4 flex-shrink-0" />
      <span>PDF generation is not available offline. Please reconnect to generate or download PDFs.</span>
    </div>
  );
}
